import React from 'react';
import { Form, FormControlProps, OverlayProps, OverlayTrigger, Tooltip } from 'react-bootstrap';
import clsx from 'clsx';

export interface BzFormControlProps {
  placeholder?: string;
  invalid?: boolean;
  /** Shows when invalid flag is true */
  invalidMessage?: string;
  /** Indicates whether the field was modified by the user */
  dirty?: boolean;
  validating?: boolean;
  required: boolean;
  className?: string;
  name?: string;
  /** Errors can be hidden and shown in a custom place if needed */
  hideErrors?: boolean;
  pattern?: string;
  defaultValue?: string;
  autoComplete?: string;
  title?: string;
  /** If set to true, the tooltip component is displayed False by default */
  tooltipEnabled?: boolean;
  tooltipPosition?: 'left' | 'bottom' | 'right' | 'top';
}

export interface BzOverlayProps {
  id: string;
  title?: string;
  defaultShow?: boolean;
}

/**
 * Provides input form control that enables showing validation errors
 * It can be used by the wrapper BzFormControlWithHook in case of usage of useFormInput hook to provide the validations
 */

const BzFormControl = React.forwardRef((props: BzFormControlProps & FormControlProps, ref: any) => {
  const title = props.title ? props.title : props.placeholder;
  const renderTooltip = (overlayProps: BzOverlayProps & OverlayProps) => {
    return (
      <Tooltip {...overlayProps}>
        <div style={{ margin: '0', textAlign: 'left' }}>{title} </div>
      </Tooltip>
    );
  };

  const formControl = (
    <Form.Control
      type={props.type}
      autoComplete={props.autoComplete}
      defaultValue={props.defaultValue}
      onChange={props.onChange}
      placeholder={props.placeholder}
      className={clsx(props.className, props.invalid && props.dirty && 'is-invalid')}
      aria-invalid={!props.invalid}
      aria-required={props.required}
      value={props.value}
      id={props.id}
      name={props.name}
      disabled={props.disabled}
      pattern={props.pattern}
      readOnly={props.readOnly}
      ref={ref}
    />
  );

  return (
    <>
      {props.tooltipEnabled === true ? (
        <OverlayTrigger
          placement={props.tooltipPosition ? props.tooltipPosition : 'right'}
          overlay={renderTooltip as any}
        >
          {formControl}
        </OverlayTrigger>
      ) : (
        <>{formControl}</>
      )}
      {!props.hideErrors && props.invalid && (props.dirty || props.validating) && (
        <div className="invalid-feedback">{props.invalidMessage}</div>
      )}
    </>
  );
});
BzFormControl.displayName = 'BzFormControl';
export default BzFormControl;
